import html2canvas from 'html2canvas'
import { toast } from 'react-toastify'

function useGenerateImage() {
  const generateImage = async (
    ref: React.RefObject<HTMLElement>,
    fileName = 'exported-image.png',
  ) => {
    if (!ref?.current) {
      return
    }

    try {
      const canvas = await html2canvas(ref.current, {
        useCORS: true,
        scale: 2,
      })
      const dataUrl = canvas.toDataURL('image/png')

      const link = document.createElement('a')
      link.href = dataUrl
      link.download = fileName
      link.click()
      toast.success('Image save succefully.')
    } catch (error) {
      toast.error('Failed to save as Image')
    }
  }

  return { generateImage }
}

export default useGenerateImage
